import * as React from "react";
import { StaticImage } from "gatsby-plugin-image";
import {
  Accordions,
  Accordionsitems,
  AccordionsContent,
  AccordionsContentinner,
  AccordionsTitle,
} from "../Accordion";
import {
  Section,
  SectionDescription,
  Container,
  SectionTitle,
  FaqGrid,
  FaqLeftGrid,
  FaqRightGrid
} from "../Section";

const PageBlockFaq = ({ data }) => {
  console.log(data.contents);
  const [activeFaq, setActiveFaq] = React.useState(0);

  const handleAccodion = (key) => {
    if (activeFaq === key) {
      return setActiveFaq(null);
    }
    setActiveFaq(key);
  };

  // const faqData = [
  //   {
  //     question: "How much do metal buildings cost?",
  //     answer: "On average, metal buildings cost around $11-$20 per square foot. The final price for your structure depends on size, custom features, and local site conditions.",
  //   },
  //   {
  //     question: "What’s the difference between a certified and non-certified metal building?",
  //     answer: "Certified metal buildings are engineered to meet local building codes, especially for wind and snow loads. If your area requires permits, you'll likely need a certified building. Non-certified buildings are more basic and may work for areas without strict code requirements.",
  //   },
  //   {
  //     question: "What is a pre-engineered metal building?",
  //     answer: "A pre-engineered metal building is a structure that’s designed and manufactured in a factory and then delivered to your site ready for assembly.",
  //   },
  //   {
  //     question: "How long does it take to deliver and install a metal building?",
  //     answer: "Delivery and installation typically take 4 to 8 weeks, depending on your location, weather, and how complex your customizations are.",
  //   },
  //   {
  //     question: "Do metal buildings come with a warranty?",
  //     answer: "Yes! Our metal buildings come with a 20-year rust-through warranty on the panelling and framing.",
  //   },
  //   {
  //     question: "How do I purchase a metal building through EMB Metal Buildings?",
  //     answer: "<p>Designing and purchasing a metal building from EMB is easy and straightforward. You’ll want to:</p><ul><li>Go online and use our 3D metal building estimator to customize your building.</li><li>Or call our building experts and work together on the design.</li><li>Get a FREE, no-obligation price quote.</li><li>Make your down payment to reserve your order.</li><li>Prepare your foundation and secure any required permits.</li><li>Schedule your installation and get ready to enjoy your new building!</li></ul>",
  //   }
  // ]

  if (!data) {
    return '';
  }

  return (
    <Section
      ept="60px"
      epb="60px"
      xpt="40px"
      xpb="40px"
      pt="30px"
      pb="30px"
      bgColor="#fff"
    >
      <Container>
        <SectionTitle mb="20px" textAlign="center" >
          {data.title}
        </SectionTitle>
        <SectionDescription textAlign="center" maxWidth="1120px" dangerouslySetInnerHTML={{
          __html: data.subTitle.childMarkdownRemark.html,
        }} />
        <FaqGrid>
          <FaqLeftGrid>
            <Accordions className="accordions">
              {data.contents.map((item, index) => (
                <Accordionsitems
                  className={`accordions-items ${activeFaq === index ? "active" : ""}`}
                  key={index}
                >
                  <AccordionsTitle
                    className="accordions-title"
                    onClick={() => handleAccodion(index)}
                  >
                    <i></i>
                    <strong>{item.question}</strong>
                    <span></span>
                  </AccordionsTitle>
                  <AccordionsContent className="accordions-content">
                    <AccordionsContentinner dangerouslySetInnerHTML={{ __html: item.answer.childMarkdownRemark.html }} />
                  </AccordionsContent>
                </Accordionsitems>
              ))}
            </Accordions>
          </FaqLeftGrid>
          <FaqRightGrid>
            <StaticImage src="../images/faq-charator.png" alt="Faq" />
          </FaqRightGrid>
        </FaqGrid>
      </Container>

    </Section>
  );
};

export default PageBlockFaq;
